import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import { readStorefrontTenant } from "lib/storefront";
import { resolveStorefrontAssetUrl } from "lib/storefrontTheme";
import EdsWordmark from "./EdsWordmark";

const VARIANTS = {
  header: { height: 42, maxWidth: 200, wordmarkSize: "sm" },
  signIn: { height: 52, maxWidth: 240, wordmarkSize: "lg" },
  footer: { height: 38, maxWidth: 180, wordmarkSize: "md" },
};

export default function EdsLogo({ variant, light, alt, logoUrl, centered }) {
  const { tenant } = useStorefrontTenant();
  const cached = readStorefrontTenant();
  const preset = VARIANTS[variant] || VARIANTS.header;
  const resolvedLogoUrl = logoUrl || tenant?.brandLogoUrl || cached?.brandLogoUrl;
  const brandLogo = resolveStorefrontAssetUrl(resolvedLogoUrl);
  const brandName = tenant?.name || cached?.name || "Elite Drive Solutions";

  if (brandLogo) {
    return (
      <Box
        component="img"
        src={brandLogo}
        alt={alt || brandName}
        sx={{
          height: preset.height,
          width: "auto",
          maxWidth: preset.maxWidth,
          display: "block",
          mx: centered ? "auto" : undefined,
          objectFit: "contain",
          objectPosition: centered ? "center center" : "left center",
        }}
      />
    );
  }

  return (
    <Box sx={{ display: "flex", justifyContent: centered ? "center" : "flex-start" }}>
      <EdsWordmark light={light} size={preset.wordmarkSize} />
    </Box>
  );
}

EdsLogo.propTypes = {
  variant: PropTypes.oneOf(["header", "signIn", "footer"]),
  light: PropTypes.bool,
  alt: PropTypes.string,
  logoUrl: PropTypes.string,
  centered: PropTypes.bool,
};

EdsLogo.defaultProps = {
  variant: "header",
  light: false,
  alt: "",
  logoUrl: undefined,
  centered: false,
};
